import { Route } from '@angular/router';

import { environment } from 'environments/environment';

import { LayoutComponent } from '../app/layout/layout.component';
import { LogoutComponent } from './modules/public/logout/logout.component';
import { LockedAccountComponent } from './shared/components/locked-account/locked-account.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { ExternalLinkGuard } from './shared/guards/external-link.guard';

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: 'resources/education',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/news-events/category/education/`,
				},
			},
			{
				path: 'resources/most-collected-wines-of-2023',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/most-collected-wines-of-2023/`,
				},
			},
			{
				path: 'resources/glossary',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/resources/glossary-wine-terms/`,
				},
			},
			{
				path: 'resources/provenance-program',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/provenance-program`,
				},
			},
			{
				path: 'resources/faq',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/resources/frequently-asked-questions/`,
				},
			},
			{
				path: 'about',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/about/`,
				},
			},
			{
				path: 'manage-cellarage-offering',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/storage/managed-cellarage/`,
				},
			},
			{
				path: 'about/manage-cellarage-offering',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/storage/managed-cellarage/`,
				},
			},
			{
				path: 'about/terms-and-conditions',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/terms-and-conditions/`,
				},
			},
			{
				path: 'about/cellar-locations',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/storage/locations/`,
				},
			},
			{
				path: 'about/why-wine-ark',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/about/choose-wine-ark/`,
				},
			},
			{
				path: 'about/testimonials',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/about/customer-testimonials/`,
				},
			},
			{
				path: 'contact',
				canActivate: [ExternalLinkGuard],
				component: ExternalLinkGuard,
				data: {
					externalUrl: `${environment.baseWineArkUrl}/contact/`,
				},
			},
			{
				path: '',
				loadChildren: () => import('app/modules/public/public.routing').then((x) => x.PublicRoutes),
			},
		],
		data: {
			title: '',
			skipBreadcrumb: true,
		},
	},
	{
		path: 'auth-callback',
		component: LayoutComponent,
		children: [],
	},
	// {
	// 	path: 'account',
	// 	canActivate: [AuthGuard],
	// 	component: LayoutComponent,
	// 	children: [
	// 		{
	// 			path: '',
	// 			loadChildren: () => import('app/modules/private/private.routing').then((x) => x.PrivateRoutes),
	// 		},
	// 	],
	// 	data: {
	// 		title: 'Account',
	// 	},
	// },
	{
		path: 'logout',
		component: LogoutComponent,
	},
	{
		path: '**',
		redirectTo: 'not-found',
		data: {
			title: 'Not Found',
		},
	},
	{
		path: 'account-locked',
		canActivate: [AuthGuard],
		component: LockedAccountComponent,
		data: {
			title: 'Account Locked',
			breadcrumb: 'Account Locked',
		},
	},
];
